import React from 'react'
import {
  ScrollbarWrapper,
  SliderWrapper,
  GridPublicationItemPlaceholder,
} from './PublicationSlider.styles'

const PublicationSliderPlaceholder = () => (
  <ScrollbarWrapper>
    <SliderWrapper>
      <GridPublicationItemPlaceholder />
      <GridPublicationItemPlaceholder />
      <GridPublicationItemPlaceholder />
      <GridPublicationItemPlaceholder />
    </SliderWrapper>
  </ScrollbarWrapper>
)

export default PublicationSliderPlaceholder
